<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-actions>
        <img :src="require(`../assets/img/popup/${popupIconType}.svg`)">
        {{popupItem}}
        <img v-if="popupItem != 'Winning' && popupItem != 'Thanks' "
          :src="require(`../assets/img/popup/${popupIconType}Title.svg`)">
        <!-- 什麼是隨機代碼 -->
        <div class="item" v-if="popupItem== 'Question'">
          <ol>
            <li>如為紙本電子發票，可於發票號碼下方小字看見發票隨機碼並手動輸入。</li>
            <li>如為電子載具，請於開立發票之載具中，以手機截圖當筆發票存摺之消費明細並上傳。</li>
            <br>
          </ol>
          <v-btn text @click="closePopup">X</v-btn>
        </div>
        <!-- /什麼是隨機代碼 -->
        <!-- 填完表單後，是否要玩遊戲 -->
        <div class="item" v-if="popupItem== 'Check'">
          <p>恭喜你獲得好好生活禮抽獎資格！<br><span v-if="prize == ''">首次登錄發票還能玩春風貓輪盤，快試手氣把LINE POINTS抽回家~</span></p>
          <p>（中獎者及獎項內容將於發票審核無誤後發放）</p>
          <span v-if="prize != ''">
            <!-- 不玩遊戲 顯示得獎資訊 -->
            你已玩過春風貓輪盤，<br>
            <span v-if="prize != '銘謝惠顧'">恭喜獲得{{prize}}點 LINE POINTS。</span>
            <span v-if="prize == '銘謝惠顧'">繼續加油！再接再厲～</span>
            <br>
            還有iPhone14等多項好禮等你抽唷！<br><br>
            *此活動限玩一次(每個帳號為基準)<br>*獎項將於審核發票資格無誤後發放。
          </span>
          <a href="#" @click="$addTags(tags.btnGoPlay,null,null,{path: '/gamPage'})" to="/gamPage"><img
              v-if="prize == ''" src="../assets/img/from/btnGoPlay.png"></a>
          <a href="#" @click="$addTags(tags.gotoIndex,null,null,{path: '/'})"><img v-if="prize != ''"
              src="../assets/img/from/btnBackToIndex.png"></a>
        </div>
        <!-- /填完表單後，是否要玩遊戲 -->
        <!-- 玩完輪盤後，顯示恭喜中獎或未中獎 -->
        <div class="item" v-if="popupItem == 'Winning' || popupItem == 'Thanks' ">
          <br>
          <p v-if="prize != '銘謝惠顧'">恭喜你抽中<br>
            <strong>{{prize}} 點 LINE POINTS</strong><br>
          </p>
          <span v-if="prize != '銘謝惠顧'">中獎發票發票號碼：{{inv_number}}</span>
          <p v-if="prize == '銘謝惠顧'">
            <strong>再接再厲，還有iPhone14<br>等多項好禮等你抽唷！</strong>
          </p>
          <span>*您的抽獎結果如圖<br>（可點擊右上選單春風貓輪盤查看）<br>*春風貓輪盤每個帳號限玩一次<br>*如有中獎，獎項將於審核發票資格無誤後發放。</span>
          <a href="#"
            @click="$addTags(popupItem == 'Winning'? tags.winGotoIndex : tags.notWinGotoIndex ,null,null,{path: '/'})"><img
              src="../assets/img/from/btnBackToIndex.png"></a>
          <!-- <router-link to="/"><img src="../assets/img/from/btnBackToIndex.png"></router-link> -->
        </div>
        <!-- /玩完輪盤後，顯示恭喜中獎或未中獎 -->
        <!-- 邀請好友 -->
        <div class="item" v-if="popupItem== 'Friend'">
          <p>請填寫AeSHOP會員手機門號<br>以利後續LINE POINTS發放</p>
          <v-form ref="form" v-model="Friend" lazy-validation>
            <!-- 綁定AeSHOP會員 -->
            <v-text-field v-model="mobile" :rules="mobileRules" :counter="10" solo required label="請輸入AeSHOP手機門號">
            </v-text-field>
            <v-row>
              <v-col cols="7" v-if="canSendTime !=0">
                <v-text-field v-model="verificationNB" :rules="verificationNBRules" :counter="6" solo required
                  label="請輸入驗證碼">
                </v-text-field>
              </v-col>
              <v-col cols="5">
                <v-btn id="getVerificationCode" :class="{'reciprocal':canSendTime !=0}"
                  @click="canSendTime == 0 && getVerificationNB()">
                  <span v-if="canSendTime !=0">{{canSendTime}}秒後</span>
                  取得驗證碼
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <googleRecapcha ref='googleRecapcha' @getGoogle="getGoogleRecapcha"></googleRecapcha>
          <a href="#" v-if="verificationNB && verificationNB.length==6"
            @click="googleVerify(),$addTags(tags.submit,null,null)"><img src="../assets/img/friend/submit.svg"></a>
          <!--<router-link to="/"><img src="../assets/img/friend/submit.png"></router-link>-->
          <br>
          <a href="#" @click="goAeSHOP(), $addTags(tags.goAeSHOP,null,null,null)" class="toAeShop"><img
              src="../assets/img/friend/toAeShop.svg"></a>
        </div>
        <!-- /邀請好友 -->
        <!-- 個資法 -->
        <div class="item" v-if="popupItem== 'Information'">
          <div class="InformationBox">
            <p>(一)依據個人資料保護法(以下稱個資法)第八條一項規定，應向活動參加者告知下列事項：
              <ol>
                <li>蒐集個人資料之主體：正隆股份有限公司(以下稱本公司)</li>
                <li>蒐集之目的：作為參與本次本公司促銷活動，抽獎聯繫及後續相關程序之使用。</li>
                <li>蒐集之類別：姓名、身分證字號、聯絡電話、行動電話、寄送地址、戶籍地址。</li>
              </ol>
            </p>
            <p> (二)個人資料利用之期間、地區、對象及方式
              <ol>
                <li>期間：抽獎活動期間(包括後續寄送及相關程序執行完畢)</li>
                <li>地區：本國</li>
                <li>對象：本公司、本公司委託機關及執行活動時之必要相關人員</li>
              </ol>
            </p>
            <p> (二)個人資料利用之期間、地區、對象及方式
              <ol>
                <li>期間：抽獎活動期間(包括後續寄送及相關程序執行完畢)</li>
                <li>地區：本國</li>
                <li>對象：本公司、本公司委託機關及執行活動時之必要相關人員</li>
                <li>方式：以自動化機器或其他非自動化之利用方式</li>
                <li>活動參加者同意本公司得將其部分姓名與電話，公佈於活動網站或相關行銷活動網站或宣傳物中並同意本公司蒐集其姓名及聯絡方式（電話、地址或E-Mail）作為贈獎聯繫使用。</li>
              </ol>
            </p>
            <p>(三)依據個資法第三條規定，活動參與者就其提供之個人資料，得行使下列之權利：<br>
              依個人資料保護法的規定，活動參與者就本公司保有的個人資料，得請求行使查詢或閱覽、製給複製本、補充或更正、停止蒐集處理或利用、刪除之權利；惟本公司依法應執行職務所必要者，得不依活動參與者之請求為之。</p>
            <p> (四)不提供個人資料所致之權益影響：<br>
              活動參與者可自由選擇是否提供個人資料予本公司，若拒絕提供者，恕無法參加本活動。並且經檢舉其個人資料冒用、盜用、資料不實或其他情事足以確認活動參與者身分不符等情形，致本公司無法進行必要之確認作業，本公司保有停止本活動相關服務提供之權利，如有不便之處，敬請見諒。
            </p>
            <v-btn text @click="closePopup">X</v-btn>
          </div>
        </div>
        <!-- /個資法 -->
        <!-- 查詢指定通路發票 -->
        <div class="item" v-if="popupItem== 'Bill'">
          <div class="bill" v-if="new Date() > new Date(this.startTime)">
            <p v-for="item in bill" :key="item.sellerName">
              {{item.val}} :
              <span v-if="new Date(item.startTime) > new Date() ">活動發票尚在審核中</span>
              <span v-else-if="sellerName.find(x => x.sellerName == item.sellerName)">獲得30點 LINE POINTS</span>
              <span v-else>已額滿</span>
            </p>
          </div>
          <p v-if="new Date() < new Date(this.startTime)"><strong>活動發票<br>尚在審核階段</strong>
          </p>
          <span>*審核時間為7-14個工作天
            <br>*中獎名單：於12/14(三)公佈
            <br>*點數將統一於12/15-12/23內發放
            <br>(不包含假日)</span>
          <a href="#" @click="closePopup"><img src="../assets/img/from/btnBackToIndex.png"></a>
        </div>
        <!-- /查詢指定通路發票 -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from "axios";
  import swal from 'sweetalert2'
  import googleRecapcha from '@/components/googleRecapcha.vue';
  import liff from '@line/liff';
  // import { markRaw } from "vue";
  export default {
    name: 'popupBox',
    props: ['popupIconType', 'popupItem', 'prize', 'canSendTime', 'inv_number', 'sellerName'],
    components: {
      googleRecapcha,
    },
    data: () => ({
      startTime: '2022-11-04',
      bill: [{
        sellerName: '大潤發',
        startTime: '2022-11-04',
        val:'大潤發'
      }, {
        sellerName: '全聯',
        startTime: '2022-11-11',
        val:'全聯'
      }, {
        sellerName: '正隆',
        startTime: '2022-11-19',
        val:'AeSHOP'
      }],
      reciprocalTime: '',
      dialog: true,
      gCAPTCHA_token: '',
      Friend: '',
      mobile: '',
      mobileRules: [
        v => (!!v && v.length == 10) || '請輸入手機門號',
      ],
      verificationNB: '',
      verificationNBRules: [
        v => (!!v && v.length == 6) || '請輸入驗證碼',
      ],
      tags: {
        'btnGoPlay': '7BA233DA54ED44B28B6295456A94C806',
        'gotoIndex': '5CD658A4C98747A584CEE43F35EB8720',
        'winGotoIndex': 'E988966BDB904901A8CF4F012EEF19BD',
        'notWinGotoIndex': '124BE4EF4209443A872D6FCFEC3838D6',
        'submit': 'DF45729B607D4FD0812176FC73350BBC',
        'goAeSHOP': '65B1D11CFE0C488BA079E56F74461671'
      }
    }),
    methods: {
      // 取得驗證碼
      getVerificationNB() {
        var me = this;
        me.url = '/Liff/GetData_SmsVerificationCode/73BA0156B2CD455281A9F7886001985A'
        var config = {
          method: "post",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + me.url,
          data: new FormData()
        }
        config.data.append("mobile", me.mobile);
        swal.fire({
          didOpen: () => {
            swal.fire({
              allowOutsideClick: false
            });
            swal.showLoading();
            axios(config).then(res => {
              var data = res.data;
              if (data && data.success) {
                // // 取得驗證碼的倒數秒數
                me.getCanSendTime()
              } else {
                alert(data.message);
              }
            }).catch((err) => {
              console.log(err)
              alert("系統忙碌中，請稍後再試");
            }).finally(() => {
              swal.close();
            })
          }
        })
      },
      // 取得驗證碼的倒數秒數
      getCanSendTime() {
        var me = this;
        me.url = '/Liff/GetData_SmsCanSendTime/54CF6E71502D44198838C6C21DA43F0A'
        var config = {
          method: "get",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + me.url,
        }
        swal.fire({
          didOpen: () => {
            swal.fire({
              allowOutsideClick: false
            });
            swal.showLoading();
            axios(config).then(res => {
              var data = res.data;
              if (data && data.success) {
                me.canSendTime = data.data
                // 剩餘秒數
                me.aTime()
              }
            }).catch((err) => {
              console.log(err)
              alert("系統忙碌中，請稍後再試");
            }).finally(() => {
              swal.close();
            })
          }
        })
      },
      // 剩餘秒數
      aTime() {
        var me = this;
        if (me.canSendTime != 0) {
          setTimeout(() => {
            me.canSendTime--;
            me.aTime();
          }, 1000);
        }
      },
      // 打googleRecapcha
      googleVerify() {
        this.$refs.googleRecapcha.execute();
      },
      // 獲得googleRecapcha 資料
      getGoogleRecapcha(val) {
        this.gCAPTCHA_token = val
        this.validateMobile()
      },
      // 驗證表單之後送出
      validateMobile() {

        var me = this;
        me.url = '/Liff/EditData_SmVerifyStatus/45D21FCFDF104386939F9E34ADF4028E'
        var config = {
          method: "post",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + me.url,
          data: new FormData()
        }
        config.data.append("code", me.verificationNB);
        config.data.append("gCAPTCHA_token", me.gCAPTCHA_token);
        swal.fire({
          didOpen: () => {
            swal.fire({
              allowOutsideClick: false
            });
            swal.showLoading();
            axios(config).then(res => {
              var data = res.data;
              if (data && data.success) {
                me.closePopup()
                me.$emit("changeAeMember", true)
              } else {
                alert(data.message);
              }
            }).catch((err) => {
              console.log(err)
              alert("系統忙碌中，請稍後再試");
            }).finally(() => {
              swal.close();
            })
          }
        })
      },
      // 在line liff裡開網頁
      goAeSHOP() {
        liff.openWindow({
          url: "https://pse.is/4f5ggc",
          external: false,
        });
      },
      closePopup() {
        this.$emit("popupStatus", false);
      },
    },
  }
</script>
<style lang="scss">
  #app {
    .message {
      font-size: 13px;
      color: #C35238;
      margin-bottom: 10px;
    }

    .v-dialog {
      overflow-y: inherit;
    }

    .v-btn {
      width: 100%;
    }

    #getVerificationCode {
      color: #000000;
      border-radius: 20px;
      padding: 15px;
      background-color: #EBD559 !important;

      span {
        display: block;
      }

      &.reciprocal {
        border: 1px dashed #EBD559;
        background-color: #ffffff !important;
        padding: 5px 15px;
      }
    }
  }

  .item .InformationBox {
    max-height: 24vh;
    overflow-y: scroll;

    p {
      margin-bottom: 15px !important;
      text-align: left !important;
      font-size: 14px !important;
      color: #222222 !important;
    }
  }



  .v-dialog {
    overflow-y: inherit;
    box-shadow: none;

    .theme--light.v-sheet {
      background-color: rgb(255 255 255 / 0%);
    }

    .v-sheet.v-card:not(.v-sheet--outlined) {
      box-shadow: none;
    }

    .v-card {
      position: relative;

      .v-card__title {
        position: absolute;
        left: 17%;
        top: -28%;
      }
    }

    .v-sheet.v-card,
    .v-card__actions {
      border-radius: 12px;
    }

    .v-card__actions {
      overflow: hidden;
      background-color: #ffffff;
      flex-direction: column;
      box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);

      >img {
        &:first-child {
          position: absolute;
          top: -55px;
        }

        &+img {
          margin-top: 60px;
        }
      }

      .item {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 90%;

        div.bill {
          margin-bottom: 10px;

          p {
            color: #222222;
            font-size: 16px;
          }

        }

        >img {
          margin-top: 30px;
          width: 195px;
        }

        strong {
          font-size: 24px;
        }

        p,
        .v-form {
          width: 100%;
        }

        strong+span,
        p+span,
        span+span,
        .bill+span {
          margin: 10px 0 20px 0;
          color: #C35238;
          font-size: 12px;
          text-align: center;
        }

        p {
          margin: 0;
          font-size: 16px;
          text-align: center;

          &+p {
            font-size: 12px;
            color: #858585;
          }
        }
      }

    }
  }
</style>